function Home() {
  return (
    <section className="section-wrap fade-up">
      <div className="glass-panel relative overflow-hidden px-5 py-10 text-center sm:px-8 sm:py-14">
        <div className="absolute -left-8 top-6 h-24 w-24 rounded-full bg-emerald-300/20 blur-2xl" />
        <div className="absolute -right-8 bottom-6 h-24 w-24 rounded-full bg-emerald-500/15 blur-2xl" />

        <p className="section-kicker mb-5">Home</p>

        <div className="mx-auto h-52 w-full max-w-sm overflow-hidden rounded-2xl border-2 border-emerald-300/25 bg-emerald-800/50 p-1 shadow-2xl shadow-emerald-900/40 sm:h-64 sm:max-w-lg">
          <img src="/aurapic.jpg" alt="Profile" className="h-full w-full rounded-xl object-cover object-center" />
        </div>

        <h1 className="mx-auto mt-7 max-w-3xl text-balance text-4xl font-bold leading-tight text-emerald-50 sm:text-5xl lg:text-6xl">
          Hi, I'm Srinesh!
        </h1>

        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-emerald-100 sm:text-xl">
          I'm an honors computer science student at NJIT based in the New York metropolitan area, passionate about all things tech.
        </p>

        <p className="mx-auto mt-3 max-w-2xl text-base leading-relaxed text-emerald-300 sm:text-lg">
          I'm currently working on improving my software engineering skills!
        </p>

        <div className="mx-auto mt-7 h-px w-36 bg-gradient-to-r from-transparent via-emerald-300/60 to-transparent" />
      </div>
    </section>
  );
}

export default Home; 